<template>
  <div>
    <the-headersider />

    <base-card class="card">
      <h2 class="title">Receive Payment</h2>

      <form @submit.prevent="createPayment">
  <!-- CLIENT AUTOCOMPLETE -->
  <div class="form-control">
    <label class="label">Client</label>

    <input
      type="text"
      v-model="clientSearch"
      placeholder="Search by Client ID, Name or Phone"
      class="input"
      @focus="showDropdown = true"
    />

    <div v-if="showDropdown" class="dropdown">
      <div
        v-for="client in filteredClients"
        :key="client.id"
        class="dropdown-item"
        @click="selectClient(client)"
      >
        <strong>{{ client.client_id }}</strong>
        <span>{{ client.name }}</span>
        <small>{{ client.phone }}</small>
      </div>

      <div v-if="filteredClients.length === 0" class="empty">
        No matching clients
      </div>
    </div>

    <p v-if="selectedClient" class="selected">
      Selected:
      <strong>{{ selectedClient.name }}</strong>
      ({{ selectedClient.phone }})
    </p>
  </div>

  <!-- AMOUNT -->
  <div class="form-control">
    <label class="label">Amount</label>
    <input type="number" class="input" v-model="formData.amount" required />
  </div>

  <!-- PAYMENT TYPE -->
  <div class="form-control">
    <label class="label">Payment Type</label>
    <select class="input" v-model="formData.payment_type" required>
      <option disabled value="">Select payment type</option>
      <option>MPESA Manual</option>
      <option>CASH Manual</option>
      <option>CHEQUE Manual</option>
    </select>
  </div>

  <!-- REFERENCE -->
  <div class="form-control">
    <label class="label">Reference</label>
    <input type="text" class="input" v-model="formData.payment_reference" />
  </div>

  <base-button class="btn" :disabled="loading || !selectedClient">
    {{ loading ? "Submitting..." : "Submit Payment" }}
  </base-button>
</form>

    </base-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      clientSearch: "",
      selectedClient: null,
      showDropdown: false,
      loading: false,

      formData: {
        client_id: "",
        amount: "",
        payment_type: "",
        payment_reference: "",
      },
    };
  },

  computed: {
    clients() {
      return this.$store.getters.clients;
    },

    filteredClients() {
      const key = this.clientSearch.toLowerCase();

      return this.clients.filter(c =>
        String(c.client_id).toLowerCase().includes(key) ||
        c.name.toLowerCase().includes(key) ||
        (c.phone && c.phone.includes(key))
      );
    },
  },

  created() {
    this.$store.dispatch("LoadClients");
  },

  methods: {
    selectClient(client) {
    this.selectedClient = client;

    // show readable value in input
    this.clientSearch = `${client.client_id} - ${client.name}`;

    // ✅ THIS IS WHAT BACKEND NEEDS
    this.formData.name = client.name;
    this.formData.client_id = client.client_id;

    this.showDropdown = false;
  },


    async createPayment() {
      if (!this.selectedClient) return;

      this.loading = true;

      try {
        await axios.post(
          "https://api.roberms.com/gla/receive/payment/",
          this.formData
        );

        this.$router.replace("/payments");
      } catch (err) {
        console.error(err);
        alert("Failed to submit payment");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.card {
  max-width: 520px;
  margin: auto;
}

.title {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

/* Inputs */
.form-control {
  margin-bottom: 0.9rem;
  position: relative;
}

.label {
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 0.3rem;
  display: block;
}

.input {
  width: 100%;
  padding: 0.65rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 0.9rem;
}

.input:focus {
  outline: none;
  border-color: #2563eb;
  background: #f8fafc;
}

/* Dropdown */
.dropdown {
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 10;
  margin-top: 0.25rem;
}

.dropdown-item {
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.dropdown-item strong {
  font-size: 0.85rem;
}

.dropdown-item span {
  font-size: 0.8rem;
}

.dropdown-item small {
  font-size: 0.75rem;
  color: #6b7280;
}

.dropdown-item:hover {
  background: #f9fafb;
}

.empty {
  padding: 0.6rem;
  text-align: center;
  font-size: 0.8rem;
  color: #9ca3af;
}

.selected {
  font-size: 0.8rem;
  margin-top: 0.3rem;
  color: #374151;
}

/* Button */
.btn {
  width: 100%;
  margin-top: 1rem;
}
</style>
